import { Heart, ShieldCheck, AlertTriangle, Ban } from "lucide-react";

export default function CommunityGuidelinesPage() {
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16" data-testid="community-guidelines-page">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">커뮤니티 가이드라인</h1>
        <p className="text-stone-500 mb-8">
          New Coupling은 <strong>따뜻한 공감과 품격 있는 만남</strong>을 위한 공간입니다.
          모든 회원이 안전하게 이용할 수 있도록 아래 원칙을 함께 지켜주세요.
        </p>

        <div className="bg-white rounded-xl border border-stone-200 p-6 space-y-7 text-sm text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-stone-800 mb-3 flex items-center gap-2">
              <Heart className="w-4 h-4 text-burgundy-500" /> 우리가 지향하는 분위기
            </h2>
            <ul className="space-y-2 pl-1">
              <li>· 서로를 존중하고, 다름을 이해하는 대화</li>
              <li>· 진솔한 일상과 감정을 나누는 글</li>
              <li>· 위로와 응원, "나도 그래요" 한마디의 공감</li>
              <li>· 중년의 지혜와 경험을 나누는 따뜻한 조언</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-3 flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-emerald-600" /> 권장하는 활동
            </h2>
            <ul className="space-y-2 pl-1">
              <li>· 본인의 진짜 이야기를 솔직하게 나누기</li>
              <li>· 정중하고 예의 바른 댓글·메시지</li>
              <li>· 다른 회원의 글에 진심 어린 공감 표현</li>
              <li>· 프로필을 정확하게 작성하여 신뢰 형성</li>
              <li>· 매칭 후 직접 만남 전 충분한 대화로 안전 확인</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-3 flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 text-amber-600" /> 주의사항 (경고 대상)
            </h2>
            <ul className="space-y-2 pl-1">
              <li>· 타인의 외모·재산·학력·직업을 비하하거나 차별하는 발언</li>
              <li>· 정치·종교·지역 갈등을 유발하는 게시글</li>
              <li>· 과도한 사적 정보(주소·계좌 등) 공개 요구</li>
              <li>· 광고성·홍보성 게시글 무단 등록</li>
              <li>· 다른 회원이 부담을 느낄 만한 반복적인 연락</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-3 flex items-center gap-2">
              <Ban className="w-4 h-4 text-red-500" /> 즉시 제재되는 금지 행위
            </h2>
            <ul className="space-y-2 pl-1">
              <li>· 타인 사칭 · 허위 신원 · 사진 도용</li>
              <li>· 성희롱 · 성적 발언 · 음란물 게시</li>
              <li>· 폭언 · 욕설 · 위협 · 스토킹</li>
              <li>· 금전 요구 · 사기 · 다단계 · 불법 권유</li>
              <li>· 외부 사이트(SNS·메신저)로 유인하여 사기 행위</li>
              <li>· 기혼자가 미혼임을 속이고 활동하는 행위</li>
              <li>· 미성년자 또는 만 19세 미만 가입·접근 시도</li>
            </ul>
            <p className="mt-3 text-xs text-stone-500 leading-relaxed">
              위 행위가 적발되면 <strong>경고 없이 계정 영구 정지 · 환불 불가 · 형사 고발</strong>이 진행될 수 있습니다.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-3">신고 및 도움 요청</h2>
            <p>피해를 입었거나 의심스러운 사용자를 발견하시면 즉시 신고해주세요.</p>
            <ul className="space-y-2 mt-2 pl-1">
              <li>· 게시글/댓글 우측 상단 <strong>신고</strong> 버튼</li>
              <li>· 프로필 페이지 <strong>차단·신고</strong> 메뉴</li>
              <li>· 이메일: <a href="mailto:contact@newcoupling.com" className="text-burgundy-500 hover:underline">contact@newcoupling.com</a></li>
            </ul>
            <p className="mt-3 text-xs text-stone-500">
              신고 내용은 24시간 이내에 확인되며, 신고자의 신원은 철저히 보호됩니다.
            </p>
          </section>

          <section className="text-xs text-stone-500 border-t border-stone-100 pt-4">
            본 가이드라인은 회사 정책 및 관련 법령에 따라 변경될 수 있으며, 변경 시 사전 공지합니다.
            가이드라인을 위반한 회원에 대한 조치는 <a href="/terms" className="text-burgundy-500 hover:underline">이용약관 제8조</a>를 따릅니다.
          </section>
        </div>
      </div>
    </div>
  );
}
